export enum MessageType {
    Chat,
    Command,
    Status,
}

export enum CommandType {
    ToggleMicrophone,
    MuteMicrophone,
}

export enum StatusType {
    Microphone,
}

export abstract class Message {
    type: MessageType;
}

export class CommandMessage extends Message {
    commandType: CommandType;
    uuids: string[];

    constructor(commandType: CommandType, uuids: string[]) {
        super();
        this.type = MessageType.Command;
        this.commandType = commandType;
        this.uuids = uuids;
    }
}

export class StatusMessage extends Message {
    statusType: StatusType;

    constructor() {
        super();
        this.type = MessageType.Status;
    }
}

export class MicrophoneStatusMessage extends StatusMessage {
    isMuted: boolean;

    constructor(isMuted: boolean) {
        super();
        this.statusType = StatusType.Microphone;
        this.isMuted = isMuted;
    }
}
